import TestimonialCard from './TestimonialCard';
import type { TestimonialsProps } from './useTestimonials';

const TestimonialsDesktop = ({ data }: TestimonialsProps) => {
  return (
    <section
      id="testimonials"
      className="flex flex-col items-center gap-15 bg-surface-card px-20 py-25"
    >
      <div className="flex max-w-[600px] flex-col items-center gap-4 text-center">
        <span className="font-body text-sm font-semibold tracking-widest text-accent-text">
          {data.label}
        </span>
        <h2 className="font-heading text-5xl font-medium text-foreground-primary">
          {data.title}
        </h2>
      </div>

      <div className="grid w-full grid-cols-3 gap-8">
        {data.testimonials.map((testimonial, index) => (
          <TestimonialCard key={index} testimonial={testimonial} />
        ))}
      </div>
    </section>
  );
};

export default TestimonialsDesktop;
